<template>
    <div class="form-container">
        <h2>排查填报</h2>
        <el-form :model="form" label-width="150px" :rules="rules" ref="inspectionForm">
            <!-- 位置信息 -->
            <el-form-item label="市（必填）" prop="city">
                <el-select v-model="form.city" placeholder="请选择市">
                    <el-option v-for="item in cities" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="区县（必填）" prop="district">
                <el-select v-model="form.district" placeholder="请选择区县">
                    <el-option v-for="item in districts" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="所属流域（必填）" prop="basin">
                <el-input v-model="form.basin" placeholder="请输入所属流域"></el-input>
            </el-form-item>

            <el-form-item label="受纳水体（必填）" prop="receivingWater">
                <el-input v-model="form.receivingWater" placeholder="请输入受纳水体名称"></el-input>
            </el-form-item>

            <el-form-item label="河流等级（必填）" prop="riverLevel">
                <el-select v-model="form.riverLevel" placeholder="请选择">
                    <el-option label="干流" value="干流"></el-option>
                    <el-option label="一级支流" value="一级支流"></el-option>
                    <el-option label="二级支流" value="二级支流"></el-option>
                    <el-option label="三级支流" value="三级支流"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="经度">
                <el-input v-model="form.longitude" disabled placeholder="系统自动生成（保留6位小数）"></el-input>
            </el-form-item>

            <el-form-item label="纬度">
                <el-input v-model="form.latitude" disabled placeholder="系统自动生成（保留6位小数）"></el-input>
            </el-form-item>

            <el-form-item label="点位名称（必填）" prop="pointName">
                <el-input v-model="form.pointName" type="textarea" placeholder="例如：XX桥下游50米右岸排污口"></el-input>
            </el-form-item>

            <!-- 排查阶段信息 -->
            <el-form-item label="问题类型（必填）" prop="problemType">
                <el-select v-model="form.problemType" placeholder="请选择问题类型">
                    <el-option v-for="type in problemTypes" :key="type" :label="type" :value="type"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="问题描述（必填）" prop="problemDesc">
                <el-input v-model="form.problemDesc" type="textarea" :rows="3" placeholder="准确描述存在的问题..."></el-input>
            </el-form-item>

            <el-form-item label="排查日期">
                <el-date-picker v-model="form.inspectionDate" type="date" disabled placeholder="系统自动生成"></el-date-picker>
            </el-form-item>

            <el-form-item label="现场排查照片（必填）" prop="inspectionPhotos">
                <el-upload
                        action="#"
                        :auto-upload="false"
                        list-type="picture-card"
                        :on-change="handlePhotoChange"
                        :file-list="photoFiles"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>

            <!-- 检测信息 -->
            <el-form-item label="是否快检（必填）" prop="isRapidTest">
                <el-radio-group v-model="form.isRapidTest">
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item v-if="form.isRapidTest === '否'" label="未快检原因">
                <el-input v-model="form.noRapidReason" placeholder="请说明原因"></el-input>
            </el-form-item>

            <el-form-item v-if="form.isRapidTest === '是'" label="快检结果">
                <el-row :gutter="10">
                    <el-col :span="6"><el-input v-model="form.rapidTest.pH" placeholder="pH"></el-input></el-col>
                    <el-col :span="6"><el-input v-model="form.rapidTest.COD" placeholder="COD"></el-input></el-col>
                    <el-col :span="6"><el-input v-model="form.rapidTest.ammonia" placeholder="氨氮"></el-input></el-col>
                    <el-col :span="6"><el-input v-model="form.rapidTest.totalP" placeholder="总磷"></el-input></el-col>
                </el-row>
                <el-input v-model="form.rapidTest.other" placeholder="其他" style="margin-top: 8px;"></el-input>
            </el-form-item>

            <el-form-item label="是否采样送检（必填）" prop="isSampling">
                <el-radio-group v-model="form.isSampling">
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item v-if="form.isSampling === '是'" label="采样数量">
                <el-input v-model="form.samplingCount" placeholder="例如：废水2个；地表水1个"></el-input>
            </el-form-item>

            <el-form-item v-if="form.isSampling === '是'" label="采样送检点位名称或编号">
                <el-input v-model="form.samplingPoint"></el-input>
            </el-form-item>

            <el-form-item v-if="form.isSampling === '是'" label="检测因子">
                <el-checkbox-group v-model="form.testFactors">
                    <el-checkbox label="pH"></el-checkbox>
                    <el-checkbox label="溶解氧"></el-checkbox>
                    <el-checkbox label="COD"></el-checkbox>
                    <el-checkbox label="氨氮"></el-checkbox>
                    <el-checkbox label="总磷"></el-checkbox>
                    <el-checkbox label="总氮"></el-checkbox>
                    <el-checkbox label="色度"></el-checkbox>
                    <el-checkbox label="铅"></el-checkbox>
                    <el-checkbox label="镉"></el-checkbox>
                    <el-checkbox label="砷"></el-checkbox>
                    <el-checkbox label="汞"></el-checkbox>
                    <el-checkbox label="铊"></el-checkbox>
                    <el-checkbox label="锑"></el-checkbox>
                    <el-checkbox label="铬"></el-checkbox>
                    <el-checkbox label="锰"></el-checkbox>
                    <el-checkbox label="铜"></el-checkbox>
                    <el-checkbox label="锌"></el-checkbox>
                    <el-checkbox label="其他"></el-checkbox>
                </el-checkbox-group>
                <el-input v-if="form.testFactors.includes('其他')" v-model="form.otherFactor" placeholder="请填写其他因子" style="margin-top: 8px;"></el-input>
            </el-form-item>

            <!-- 整改要求 -->
            <el-form-item label="整改建议（必填）" prop="remediationSuggestion">
                <el-input v-model="form.remediationSuggestion" type="textarea"></el-input>
            </el-form-item>

            <el-form-item label="整改期限">
                <el-date-picker v-model="form.deadline" type="date" placeholder="选择整改截止日期"></el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm('inspectionForm')">提交</el-button>
                <el-button @click="resetForm('inspectionForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: 'InspectionReportForm',
        data() {
            return {
                form: {
                    city: '',
                    district: '',
                    basin: '',
                    receivingWater: '',
                    riverLevel: '',
                    longitude: '',
                    latitude: '',
                    pointName: '',
                    problemType: '',
                    problemDesc: '',
                    inspectionDate: new Date(),
                    isRapidTest: '',
                    noRapidReason: '',
                    rapidTest: {
                        pH: '',
                        COD: '',
                        ammonia: '',
                        totalP: '',
                        other: ''
                    },
                    isSampling: '',
                    samplingCount: '',
                    samplingPoint: '',
                    testFactors: [],
                    otherFactor: '',
                    remediationSuggestion: '',
                    deadline: ''
                },
                photoFiles: [],
                cities: ['南宁市', '柳州市', '桂林市'],
                districts: ['青秀区', '兴宁区', '西乡塘区'],
                problemTypes: [
                    '涉重金属企业', '涉危险废物', '涉危险化学品', '散乱污企业', '企业违法排污',
                    '黑臭水体', '受污染水体', '垃圾倾倒', '入河排污口问题', '城镇污水处理厂问题',
                    '工业园区问题', '支流水质异常', '畜禽养殖污染', '水源地风险', '涉水投诉问题', '其他'
                ],
                rules: {
                    city: [{ required: true, message: '请选择市', trigger: 'change' }],
                    district: [{ required: true, message: '请选择区县', trigger: 'change' }],
                    basin: [{ required: true, message: '请输入所属流域', trigger: 'blur' }],
                    receivingWater: [{ required: true, message: '请输入受纳水体', trigger: 'blur' }],
                    riverLevel: [{ required: true, message: '请选择河流等级', trigger: 'change' }],
                    pointName: [{ required: true, message: '请输入点位名称', trigger: 'blur' }],
                    problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
                    problemDesc: [{ required: true, message: '请输入问题描述', trigger: 'blur' }],
                    isRapidTest: [{ required: true, message: '请选择是否快检', trigger: 'change' }],
                    isSampling: [{ required: true, message: '请选择是否采样送检', trigger: 'change' }],
                    remediationSuggestion: [{ required: true, message: '请输入整改建议', trigger: 'blur' }]
                }
            };
        },
        methods: {
            handlePhotoChange(file, fileList) {
                this.photoFiles = fileList;
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        alert('排查信息提交成功！');
                        console.log(this.form);
                    } else {
                        console.log('校验失败');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.photoFiles = [];
            }
        }
    };
</script>

<style scoped>
    .form-container {
        max-width: 900px;
        margin: 20px auto;
        padding: 20px;
        border: 1px solid #ebeef5;
        border-radius: 8px;
    }
</style>